import React from "react";

import Shape from "../components/exploreComp.js";

import "../styles/Explore.css";

const Explore = () => (
  <div class="complete">
    <Shape></Shape>
  </div>
);

export default Explore;
